<template>
  <div class="mf-loading-container">
    <img src="./loading.gif" />
    <div class="loading-txt">正在刷新</div>
  </div>
</template>
<script>
const COMPONENT_NAME = "loading";

export default {
  name: COMPONENT_NAME,
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
.mf-loading-container {
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 40px;
    height: 40px;
    display: block;
  }

  .loading-txt {
    font-size: 28px;
    color: #666666;
  }
}
</style>
